import { parseKanunMaddesi, compareKanun, compareMaddeNo, compareVaryant } from './kanunMaddeParse';

/**
 * Düz kanun-madde string listesini Kanun -> Madde -> Varyant ağacına dönüştürür.
 * Parse edilemeyenler "diger" kovasına düşer.
 *
 * Dönüş:
 * {
 *   kanunlar: [{ kanunKey, kanunLabel, count, maddeler: [
 *     { maddeKey, maddeNo, count, varyantlar: [{ canonical, fikra, bent, raw }] }
 *   ] }],
 *   diger: { count, raws: [string] }
 * }
 */
export function kanunMaddeAgaciOlustur(stringDizisi) {
  const kanunMap = new Map();
  const digerSet = new Set();
  const digerRaws = [];

  (stringDizisi || []).forEach((s) => {
    const p = parseKanunMaddesi(s);
    if (!p.parsed) {
      const r = p.raw || (typeof s === 'string' ? s : '');
      if (r && !digerSet.has(r)) {
        digerSet.add(r);
        digerRaws.push(r);
      }
      return;
    }

    let kanun = kanunMap.get(p.kanunKey);
    if (!kanun) {
      kanun = { kanunKey: p.kanunKey, kanunLabel: p.kanunLabel, maddeMap: new Map() };
      kanunMap.set(p.kanunKey, kanun);
    }

    let madde = kanun.maddeMap.get(p.maddeKey);
    if (!madde) {
      madde = { maddeKey: p.maddeKey, maddeNo: p.maddeNo, varyantMap: new Map() };
      kanun.maddeMap.set(p.maddeKey, madde);
    }

    if (!madde.varyantMap.has(p.canonical)) {
      madde.varyantMap.set(p.canonical, {
        canonical: p.canonical,
        fikra: p.fikra,
        bent: p.bent,
        raw: p.raw,
      });
    }
  });

  const kanunlar = [...kanunMap.values()]
    .map((k) => {
      const maddeler = [...k.maddeMap.values()]
        .map((m) => {
          const varyantlar = [...m.varyantMap.values()].sort(compareVaryant);
          return { maddeKey: m.maddeKey, maddeNo: m.maddeNo, count: varyantlar.length, varyantlar };
        })
        .sort((a, b) => compareMaddeNo(a.maddeNo, b.maddeNo));
      const count = maddeler.reduce((acc, m) => acc + m.count, 0);
      return { kanunKey: k.kanunKey, kanunLabel: k.kanunLabel, count, maddeler };
    })
    .sort((a, b) => compareKanun(a.kanunKey, b.kanunKey));

  return { kanunlar, diger: { count: digerRaws.length, raws: digerRaws } };
}
